export default __webpack_public_path__ + "static/media/MESZ.45837ef6.png";